import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

import { ArrowRight } from '../components/ui';

export function NotFoundPage(): ReactNode {
  return (
    <div className="inner" style={{ paddingTop: 80, paddingBottom: 120, textAlign: 'center' }}>
      <span className="eyebrow">404</span>
      <h1 style={{ marginTop: 12, fontSize: 32 }}>We could not find that page</h1>
      <p className="muted" style={{ marginTop: 12, maxWidth: '46ch', marginInline: 'auto' }}>
        That address does not match anything on this site.
      </p>
      <div className="row" style={{ justifyContent: 'center', marginTop: 26 }}>
        <Link className="pill pill-primary" to="/">
          Browse the leaderboard
          <ArrowRight />
        </Link>
      </div>
    </div>
  );
}
